<template>
  <Layout>
    <main class="pt-5 pb-3">
      <div class="container">
        <div class="card memberStep">
          <div v-if="isLoading" class="preloader-container">
            <div class="preloader"></div>
          </div>
          <div v-else>
            <div class="card-body">
              <div class="row">
                <div class="col-3"></div>
                <div class="col-6">
                  <h2 class="mainTitleSize pt-3">Pdf Application</h2>
                </div>
                <div class="col-3 mt-3 text-end">
                  <button
                    @click="downloadPDF()"
                    ref="anotherButton"
                    type="button"
                    class="btn btn-theme btn-custom-wdth"
                  >
                    Download as PDF
                  </button>
                </div>
              </div>
              <template v-if="showRadio">
                <form-wizard
                  @on-complete="onComplete"
                  ref="myWizard"
                  :start-index="startIndex"
                  step-size="xs"
                  color="#f48226"
                  @saveFormData="saveFormData"
                  class="pdf_data_form11"
                >
                  <br />
                  <br />

                  <tab-content title="">
                    <ReviewApplicantType variant="pdf" />
                  </tab-content>
                  <div style="page-break-before: always">&nbsp;</div>
                  <br />
                  <br />
                  <tab-content title="">
                    <ReviewPersonalInfo variant="pdf" />
                  </tab-content>
                  <tab-content title="">
                    <ReviewEmployment variant="pdf" />
                  </tab-content>
                  <tab-content title="">
                    <ReviewAccountActivity variant="pdf" />
                  </tab-content>
                  <tab-content title="" v-if="radioSelected1 === 'minor'">
                    <ReviewMinors variant="pdf" />
                  </tab-content>
                  <template v-if="checkFeildInput2 === true">
                    <tab-content title="">
                      <ReviewPep variant="pdf" />
                    </tab-content>
                  </template>
                  <template v-if="checkFeildInput1 === true">
                    <tab-content title="">
                      <ReviewFatca variant="pdf" />
                    </tab-content>
                  </template>

                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <tab-content title="">
                    <ReviewAccountFees variant="pdf" />
                  </tab-content>
                  <tab-content title="">
                    <ReviewNominee variant="pdf" />
                  </tab-content>
                  <tab-content title="">
                    <ReviewDeclaration variant="pdf" />
                  </tab-content>
                  <tab-content title="" v-if="showOfficial === true">
                    <ReviewOfficialUse variant="pdf" />
                  </tab-content>
                </form-wizard>
              </template>
            </div>
          </div>
        </div>
      </div>
    </main>
  </Layout>
</template>

<style>
.residency-toggle {
  display: inline-flex;
  border: 1px solid #f48226;
  border-radius: 20px;
  overflow: hidden;
}

.residency-opt {
  background: #fff;
  color: #f48226;
  border: 0;
  padding: 4px 16px;
  font-size: 14px;
  cursor: pointer;
}

.residency-opt.active {
  background: #f48226;
  color: #fff;
}

.residency-opt:disabled {
  cursor: default;
}

.preloader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.preloader {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 4px solid #f3f3f3;
  border-top-color: #f48226;
  animation: spin 1s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
<script>
import storageService from "@/services/storage.service";
import {
  FUNDING_SOURCE_CHOICES,
  INCOME_SOURCE_CHOICES,
  DOCUMENT_ISSUANCE_COUNTRIES,
} from "@/constants";
import Layout from "../../layouts/main";
import {
  ReviewApplicantType,
  ReviewPersonalInfo,
  ReviewEmployment,
  ReviewAccountActivity,
  ReviewMinors,
  ReviewPep,
  ReviewFatca,
  ReviewAccountFees,
  ReviewNominee,
  ReviewDeclaration,
  ReviewOfficialUse,
} from "@/components/forms/review";
import { provideFormContext } from "@/components/forms/formBridge";
import axios from "axios";
import statusOptionsMixin from "@/mixins/statusOptions";
import useVuelidate from "@vuelidate/core";
import base_domain from "../../myvars";
import { downloadApplicationPdf } from "@/services/pdfDownload";
import staffReviewShared from "@/mixins/staffReviewShared";
import staffReviewValidations from "@/mixins/staffReviewValidations";

export default {
  mixins: [staffReviewShared, statusOptionsMixin],
  // Step components (components/forms/review) reach this view through formBridge.
  provide: provideFormContext,

  setup() {
    return { v$: useVuelidate() };
  },
  mounted() {

    this.chkStaff();
  },
  data() {
    return {
      residencyType: null,
      imageUrl: null,
      imageUrl_two: null,
      imageUrl_three: null,
      imageUrl_four: null,
      imageUrl_five: null,
      imageUrl_six: null,
      imageUrl_seven: null,
      imageUrl_eight: null,
      fileIconUrl: "https://www.flaticon.com/free-icon/file_124837",
      submitting: false,
      incompleteAppStatus: "select",
      incompleteAppComment: "",
      showModal: false,
      selectStatusPro: "select",
      currentAppStatus: "",
      feedbackError: "",
      reviewerName: "",
      reviewDate: "",
      reviewApprovedDate: "",
      imageSrcStamp: "",
      imageSrcSig: "",
      optionsList: [],
      itemsss: [0],
      startIndex: 0,
      app_id: "",
      isLoading: false,
      showOfficial: false,
      radioSelected1: "",
      checkFeildInput1: "",
      checkFeildInput2: "",
      riskInput: "",
      app_URL: process.env.APP_URL,
      showValue: true,
      fatcaFeild: "",
      checkFeildInput: [],
      radioSelected: "",
      nationalIssuance: "",
      fundedoption: FUNDING_SOURCE_CHOICES,
      Incomeoption: INCOME_SOURCE_CHOICES,
      showRadio: true,
      preview: [],
      image: [],
      driverIssuance: "",
      passportIssuance: "",
      birthIssuance: "",
      nationalIssuanceOpt: DOCUMENT_ISSUANCE_COUNTRIES,
      form: {
        personal: {
          branchName: "",
          title: "",
          surname: "",
          firstName: "rajkumar",
          middleName: "",
          address: "",
          address_line: "",
          address_line_two: "",
          city_name: "",
          state_name: "",
          zip_code: "",
          country_name: "",
          dob: "",
          gender: "",
          numOfDependents: "",
          placeOfdob: "",
          nationality: "",
          maritalStatus: "",
          nationalIdNum: "",
          nidIssueDate: "",
          nidExpiry: "",
          nationalIssuance: "",
          naitonal_identi: "",
          drivingIdNum: "",
          didIssueDate: "",
          didExpiry: "",
          driverIssuance: "",
          passportNum: "",
          passIssueDate: "",
          passExpiry: "",
          passportIssuance: "",
          birthIdNum: "",
          birthIssuance: "",
          homePhoneNum: "",
          mobileNum: "",
          email: "",
          nidDoc: [],
          didDoc: [],
          passDoc: [],
          birthDoc: [],
          employStatus: "",
          frequencyStatus: "",
          averageIncm: "",
          user_occupation: "",
          employer: "",
          user_employer: "",
          user_w_phone_no: "",
          user_phone_no: "",
          user_isstudent: "",
          user_howlong: "",
          accFunded: "",
          accountActi: "",
          accountActiDesc: "",
          numTrans: "",
          volTrans: "",
          parentName: "",
          parentId: "",
          trusteeName: "",
          trusteeId: "",
          advisor: "",
          referredRadio: "",
          entrustedRadio: "",
          memberOfRadio: "",
          tobagoRadio: "",
          ssn_no: "",
          citizenRadio: "",
          addressRadio: "",
          incomeUsRadio: "",
          account_one: "",
          shares_amount: "",
          account_two: "",
          special_shares_amount: "",
          account_three: "",
          deposit_ac_amount: "",
          reg_fee_amount: "",
          total_amount: "",
          appointnominee_name1: "",
          appointnominee_email1: "",
          appointnominee_pno1: "",
          appointnominee_rel1: "",
          appointnominee_address1: "",
          appointnominee_dob1: "",
          appointnominee_name2: "",
          appointnominee_email2: "",
          appointnominee_dob2: "",
          appointnominee_pno2: "",
          appointnominee_rel2: "",
          appointnominee_address2: "",
          hereRadioType: true,
          trusteeRadioo: "",
          relationbenifit3: "",
          appointnominee_name3: "",
          appointnominee_pno3: "",
          socuceofincome: "",
          areaofdetails: "",
          appointnominee_email3: "",
          appointnominee_dob3: "",
          appointnominee_address3: "",
          hereRadioType_one: "",
          appliname: "",
          checkListOffice1: "",
          checkListOffice2: "",
          checkListOffice3: "",
          checkListOffice4: "",
          checkListOffice5: "",
          checkListOffice6: "",
        },
      },
    };
  },
  created() {
    const routeId = this.$route?.params?.id || this.$route?.params?.app_id;
    var app = window.location.href;
    const segments = app.split("/").filter(Boolean);
    const lastSeg = segments[segments.length - 1];
    const app_id = routeId || this.id || ((lastSeg && !isNaN(lastSeg)) ? lastSeg : (segments[segments.length - 2] || ""));
    if (app_id) {
      this.app_id = app_id;
      this.getIssueImageUrl(app_id);
    }
  },

  validations: staffReviewValidations,
  components: {
    Layout,
    ReviewApplicantType,
    ReviewPersonalInfo,
    ReviewEmployment,
    ReviewAccountActivity,
    ReviewMinors,
    ReviewPep,
    ReviewFatca,
    ReviewAccountFees,
    ReviewNominee,
    ReviewDeclaration,
    ReviewOfficialUse,
  },

  methods: {

    //   html2canvas(element).then((canvas) => {

    //     while (remainingHeight > 0) {

    downloadPDF() {
      return downloadApplicationPdf(this.$route.params.id);
    },

    getIssueImageUrl(app_id) {
      axios
        .get(`/applications/issue_image/${app_id}/`)
        .then((response) => {
          const imageUrl = response.data.url || null;
          const imageUrl_two = response.data.url_two || null;
          const imageUrl_three = response.data.url_three || null;
          const imageUrl_four = response.data.url_four || null;
          const imageUrl_five = response.data.url_five || null;
          const imageUrl_six = response.data.url_six || null;
          const imageUrl_seven = response.data.url_seven || null;
          const imageUrl_eight = response.data.url_eight || null;

          if (imageUrl !== null) {
            this.imageUrl = base_domain + imageUrl;
          }
          if (imageUrl_two !== null) {
            this.imageUrl_two = base_domain + imageUrl_two;
          }
          if (imageUrl_three !== null) {
            this.imageUrl_three = base_domain + imageUrl_three;
          }
          if (imageUrl_four !== null) {
            this.imageUrl_four = base_domain + imageUrl_four;
          }
          if (imageUrl_five !== null) {
            this.imageUrl_five = base_domain + imageUrl_five;
          }
          if (imageUrl_six !== null) {
            this.imageUrl_six = base_domain + imageUrl_six;
          }
          if (imageUrl_seven !== null) {
            this.imageUrl_seven = base_domain + imageUrl_seven;
          }
          if (imageUrl_eight !== null) {
            this.imageUrl_eight = base_domain + imageUrl_eight;
          }
        })
        .catch((error) => {
          console.error("Error fetching issue image:", error);
        });
    },

    submitFeedback() {
      var t = storageService.getItem("accessToken");
      var app = window.location.href;
      const segments = app.split("/").filter(Boolean);
      const lastSeg = segments[segments.length - 1];
      const app_id = this.id || ((lastSeg && !isNaN(lastSeg)) ? lastSeg : (this.app_id || segments[segments.length - 2] || ""));
      if (app_id) {
        this.app_id = app_id;
      }
      if (this.selectStatusPro !== "select") {
        this.feedbackError = "";
        this.submitting = true;
        this.showModal = false;
        axios
          .post(`/applications/submit_feedback/`, {
            token: t,
            app_id: app_id,
            section: this.incompleteAppStatus,
            com: this.incompleteAppComment,
            status: this.selectStatusPro,
          })
          .then(() => {
            this.selectStatusPro = "select";
            this.incompleteAppComment = "";
            this.incompleteAppStatus = "select";
            this.$router.push({ name: "application list" });
          })
          .catch((error) => {
            this.submitting = false;
            this.feedbackError =
              (error.response && error.response.data && error.response.data.error) ||
              "Could not update the status.";
          });
      }
    },

    chkStaff() {
      const t = storageService.getItem("userType");
      const tok = storageService.getItem("accessToken");
      const toke = tok;
      this.showOfficial = true;
      const routeId = this.$route?.params?.id || this.$route?.params?.app_id;
      var app = window.location.href;
      const segments = app.split("/").filter(Boolean);
      const lastSeg = segments[segments.length - 1];
      const app_id = routeId || this.id || ((lastSeg && !isNaN(lastSeg)) ? lastSeg : (this.app_id || segments[segments.length - 2] || ""));
      if (app_id) {
        this.app_id = app_id;
      }
      // Create a new Date object with today's date
      var today = new Date();

      // Format the date as YYYY-MM-DD (or any other desired format)
      var formattedDate = today.toISOString().split("T")[0];
      if (t === "staff" || t === "verification officer" || t === "admin" || t === "super_user") {
        axios
          .get(`/applications/single_application_details/${app_id}`, {
            params: { token: toke },
            headers: { Authorization: `Bearer ${toke}` },
          })
          .then((response) => {
            // Handle the response
            this.reviewerName = response.data.app_reviewer;
            this.currentAppStatus = response.data.app_data.status;
            this.reviewDate = formattedDate;
            this.reviewApprovedDate = formattedDate;
            this.imageSrcStamp = response.data.app_reviewer_stamp;
            this.imageSrcSig = response.data.app_reviewer_sign;
            this.residencyType = response.data.app_data.residency_type || null;
            if (response.data.app_data.is_adult === true) {
              this.radioSelected1 = "adult";
            } else {
              this.radioSelected1 = "minor";
            }

            if (response.data.app_data.section_a1) {
              this.form.personal.branchName =
                response.data.app_data.section_a1.branch;
              this.form.personal.title =
                response.data.app_data.section_a1.applicant_title;
              this.form.personal.firstName =
                response.data.app_data.section_a1.first_name;
              this.form.personal.middleName =
                response.data.app_data.section_a1.middle_name;
              this.form.personal.surname =
                response.data.app_data.section_a1.sur_name;
              this.form.personal.address =
                response.data.app_data.section_a1.home_address;
              this.form.personal.address_line =
                response.data.app_data.section_a1.address_line;
              this.form.personal.address_line_two =
                response.data.app_data.section_a1.address_line_two;
              this.form.personal.city_name =
                response.data.app_data.section_a1.city_name;
              this.form.personal.state_name =
                response.data.app_data.section_a1.state_name;
              this.form.personal.zip_code =
                response.data.app_data.section_a1.zip_code;
              this.form.personal.country_name =
                response.data.app_data.section_a1.country_name;
              this.form.personal.dob = response.data.app_data.section_a1.dob;
              this.form.personal.gender =
                response.data.app_data.section_a1.gender;
              this.form.personal.numOfDependents =
                response.data.app_data.section_a1.dependents;
              this.form.personal.placeOfdob =
                response.data.app_data.section_a1.place_of_birth;
              this.form.personal.nationality =
                response.data.app_data.section_a1.nationality;
              this.form.personal.maritalStatus =
                response.data.app_data.section_a1.marital;
              this.form.personal.nationalIdNum =
                response.data.app_data.section_a1.nat_identity.number;
              this.form.personal.nidIssueDate =
                response.data.app_data.section_a1.nat_identity.issue_on;
              this.form.personal.nidExpiry =
                response.data.app_data.section_a1.nat_identity.expire_on;
              this.form.personal.nationalIssuance =
                response.data.app_data.section_a1.nat_identity.isuue_country;
              this.form.personal.drivingIdNum =
                response.data.app_data.section_a1.driver.number;
              this.form.personal.didIssueDate =
                response.data.app_data.section_a1.driver.issue_on;
              this.form.personal.didExpiry =
                response.data.app_data.section_a1.driver.expire_on;
              this.form.personal.driverIssuance =
                response.data.app_data.section_a1.driver.isuue_country;
              this.form.personal.passportNum =
                response.data.app_data.section_a1.passport.number;
              this.form.personal.passIssueDate =
                response.data.app_data.section_a1.passport.issue_on;
              this.form.personal.passExpiry =
                response.data.app_data.section_a1.passport.expire_on;
              this.form.personal.passportIssuance =
                response.data.app_data.section_a1.passport.isuue_country;
              this.form.personal.birthIdNum =
                response.data.app_data.section_a1.birth_cert.number;
              this.form.personal.birthIssuance =
                response.data.app_data.section_a1.birth_cert.issue_on;
              this.form.personal.homePhoneNum =
                response.data.app_data.section_a1.home_contact;
              this.form.personal.mobileNum =
                response.data.app_data.section_a1.mob_contact;
              this.form.personal.email =
                response.data.app_data.section_a1.email;
            }
            if (response.data.app_data.section_b2) {
              this.form.personal.employStatus =
                response.data.app_data.section_b2.emp_status;
              this.form.personal.frequencyStatus =
                response.data.app_data.section_b2.pay_freq;
              this.form.personal.user_howlong =
                response.data.app_data.section_b2.emp_time;
              this.form.personal.averageIncm =
                response.data.app_data.section_b2.avg_mnth_income;
              this.form.personal.user_occupation =
                response.data.app_data.section_b2.occupation;
              this.form.personal.employer =
                response.data.app_data.section_b2.employer;
              this.form.personal.user_employer =
                response.data.app_data.section_b2.emp_address;
              this.form.personal.user_w_phone_no =
                response.data.app_data.section_b2.work_contact;
              this.form.personal.user_phone_no =
                response.data.app_data.section_b2.ext_work_contact;
              this.form.personal.user_isstudent =
                response.data.app_data.section_b2.school;
            }
            if (response.data.app_data.section_c3) {
              this.form.personal.accFunded =
                response.data.app_data.section_c3.fund_source;
              this.form.personal.accountActi =
                response.data.app_data.section_c3.mem_in_others;
              this.form.personal.accountActiDesc =
                response.data.app_data.section_c3.mem_in_others_desc;
              this.form.personal.socuceofincome =
                response.data.app_data.section_c3.socuce_of_income;
              this.form.personal.areaofdetails =
                response.data.app_data.section_c3.area_of_details;
              this.form.personal.numTrans =
                response.data.app_data.section_c3.nos_trx;
              this.form.personal.volTrans =
                response.data.app_data.section_c3.vol_trx;
            }
            if (response.data.app_data.section_d4) {
              this.form.personal.parentName =
                response.data.app_data.section_d4.incare_g.name;
              this.form.personal.parentId =
                response.data.app_data.section_d4.incare_g.identification;
              this.form.personal.trusteeName =
                response.data.app_data.section_d4.incare_t.name;
              this.form.personal.trusteeId =
                response.data.app_data.section_d4.incare_t.identification;
              this.form.personal.advisor = response.data.app_data.section_d4
                .advisor
                ? response.data.app_data.section_d4.advisor
                : "";
            }
            if (response.data.app_data.section_e5) {
              this.form.personal.entrustedRadio =
                response.data.app_data.section_e5.prom_entrust;
              this.form.personal.memberOfRadio =
                response.data.app_data.section_e5.immd_famly;
              this.form.personal.referredRadio =
                response.data.app_data.section_e5.close_prsonl;
            }
            if (response.data.app_data.section_f6) {
              this.form.personal.tobagoRadio =
                response.data.app_data.section_f6.other_citizen;
              this.form.personal.citizenRadio =
                response.data.app_data.section_f6.us_citizen;
              this.form.personal.ssn_no =
                response.data.app_data.section_f6.ssn_no;
              this.form.personal.addressRadio =
                response.data.app_data.section_f6.us_address;
              this.form.personal.incomeUsRadio =
                response.data.app_data.section_f6.givin_instruct;
            }
            if (response.data.app_data.section_g7) {
              this.form.personal.account_one =
                response.data.app_data.section_g7.shares_acc;
              this.form.personal.shares_amount =
                response.data.app_data.section_g7.shares_amt;
              this.form.personal.account_two =
                response.data.app_data.section_g7.spshares_ac;
              this.form.personal.special_shares_amount =
                response.data.app_data.section_g7.spshares_amt;
              this.form.personal.account_three =
                response.data.app_data.section_g7.deposit_ac;
              this.form.personal.deposit_ac_amount =
                response.data.app_data.section_g7.deposit_amt;
              this.form.personal.reg_fee_amount =
                response.data.app_data.section_g7.reg_fee;
              this.form.personal.total_amount =
                response.data.app_data.section_g7.total;
            }
            if (response.data?.app_data?.section_h8) {
              const sec_h8 = response.data.app_data.section_h8;
              this.form.personal.appointnominee_name1 =
                sec_h8.nominee_1?.name ?? "N/A";
              this.form.personal.appointnominee_pno1 =
                sec_h8.nominee_1?.contact ?? "N/A";
              this.form.personal.appointnominee_rel1 =
                sec_h8.nominee_1?.relation ?? "N/A";
              this.form.personal.appointnominee_address1 =
                sec_h8.nominee_1?.address ?? "N/A";
              this.form.personal.appointnominee_email1 =
                sec_h8.nominee_1?.email_address ?? "N/A";
              this.form.personal.appointnominee_dob1 =
                sec_h8.nominee_1?.applicant_dob ?? "N/A";

              this.form.personal.appointnominee_name2 =
                response.data?.app_data?.section_h8?.nominee_2?.name ?? "N/A";
              this.form.personal.appointnominee_pno2 =
                response.data?.app_data?.section_h8?.nominee_2?.contact ??
                "N/A";
              this.form.personal.appointnominee_rel2 =
                response.data?.app_data?.section_h8?.nominee_2?.relation ??
                "N/A";
              this.form.personal.appointnominee_address2 =
                response.data?.app_data?.section_h8?.nominee_2?.address ??
                "N/A";
              this.form.personal.appointnominee_email2 =
                response.data?.app_data?.section_h8?.nominee_2?.email_address ??
                "N/A";
              this.form.personal.appointnominee_dob2 =
                response.data?.app_data?.section_h8?.nominee_2?.applicant_dob ??
                "N/A";

              this.form.personal.trusteeRadioo =
                response.data?.app_data?.section_h8?.nominee_minor?.caretaker
                  ?.type ?? "N/A";
              this.form.personal.appointnominee_name3 =
                response.data?.app_data?.section_h8?.nominee_minor?.name ??
                "N/A";
              this.form.personal.appointnominee_pno3 =
                response.data?.app_data?.section_h8?.nominee_minor?.contact ??
                "N/A";
              this.form.personal.relationbenifit3 =
                response.data?.app_data?.section_h8?.nominee_minor?.relation ??
                "N/A";
              this.form.personal.appointnominee_address3 =
                response.data?.app_data?.section_h8?.nominee_minor?.address ??
                "N/A";
              this.form.personal.appointnominee_email3 =
                response.data?.app_data?.section_h8?.nominee_minor
                  ?.email_address ?? "N/A";
              this.form.personal.appointnominee_dob3 =
                response.data?.app_data?.section_h8?.nominee_minor
                  ?.applicant_dob ?? "N/A";
            }

            if (response.data?.app_data?.section_i9) {
              this.form.personal.hereRadioType =
                response.data.app_data.section_i9.decleration;
              const a1 = response.data?.app_data?.section_a1;
              this.form.personal.appliname = a1
                ? `${a1.first_name || ""} ${a1.sur_name || ""}`.trim()
                : "N/A";
              this.form.personal.nameofparent =
                response.data?.app_data?.section_d4?.incare_g?.name ?? "N/A";
              this.form.personal.nameoftrustee =
                response.data?.app_data?.section_d4?.incare_t?.name ?? "N/A";
            }
          })
          .catch((error) => {
            // Handle any errors
            console.error("Error sending email:", error);
          });
      } else {
        return true;
      }
    },
  },
};
</script>